export default {
  SET_UPDATING_SEGMENTS_IDS: (state, updatingSegmentsIds) => (state.updatingSegmentsIds = updatingSegmentsIds),
  SET_REFRESHED_SEGMENTS: (state, refreshedSegments) => (state.refreshedSegments = refreshedSegments),
  SET_SEGMENTATION_ANALYTIC_CONFIGURATION_IDS: (state, payload) => (state.segmentationAnalyticConfigurationsIds = payload),
  SET_TAGS: (state, list) => (state.tagsList = list),
  DELETE_TAG(state, deletedTag) {
    state.tagsList = state.tagsList.filter((tag) => !(tag.name === deletedTag.name && tag.color === deletedTag.color))
  },
  UPDATED_TAG(state, tagUpdated) {
    const tagIndex = state.tagsList.findIndex((tag) => tag.name === tagUpdated.oldName)

    if (tagIndex !== -1) {
      state.tagsList[tagIndex].name = tagUpdated.newName
    }
  },
}
